import React from "react";
import { Link } from "gatsby";
import { nearbySuburbs } from "@/data/locationData";

type NearbySuburbsProps = {
  suburbSlug: string;
};

function slugToName(slug: string): string {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const NearbySuburbs: React.FC<NearbySuburbsProps> = ({ suburbSlug }) => {
  const nearby = nearbySuburbs[suburbSlug];
  if (!nearby || nearby.length === 0) return null;

  return (
    <section className="py-12 bg-neutral-50">
      <div className="container mx-auto px-6 max-w-5xl">
        <h2 className="text-2xl font-bold text-neutral-800 mb-4">
          Also Serving Nearby Suburbs
        </h2>
        <div className="flex flex-wrap gap-3">
          {nearby.map((slug) => (
            <Link
              key={slug}
              to={`/locations/${slug}/`}
              className="px-4 py-2 bg-white border border-neutral-200 rounded-lg text-primary hover:bg-primary hover:text-white transition"
            >
              Dentist {slugToName(slug)}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NearbySuburbs;
